export const queryKeys = {
    // ETA queries
    etas: {
        all: ['etas'] as const,
        lists: () => [...queryKeys.etas.all, 'list'] as const,
        list: (filters: { lineId: string; stationId: string; transportMode?: string }) =>
            [...queryKeys.etas.lists(), filters] as const,
        detail: (id: string) => [...queryKeys.etas.all, 'detail', id] as const,
    },

    // Report queries
    reports: {
        all: ['reports'] as const,
        byStation: (lineId: string, stationId: string) =>
            [...queryKeys.reports.all, lineId, stationId] as const,
    },

    notices: {
        all: ['notices'] as const,
        list: (filters: { lineId?: string; stationId?: string; limit?: number }) =>
            [...queryKeys.notices.all, 'list', filters] as const,
    },

    // Weather queries
    weather: {
        all: ['weather'] as const,
        current: () => [...queryKeys.weather.all, 'current'] as const,
    },

    // Admin queries
    admin: {
        all: ['admin'] as const,
        list: () => [...queryKeys.admin.all, 'list'] as const,
        status: () => [...queryKeys.admin.all, 'status'] as const,
    },
} as const;
